import { createReducer } from "reduxsauce"
import { get } from "lodash"
import { takeLatest, select, put } from "redux-saga/effects"
import { Types as HistoryTypes } from "../../../actions/app/history"
import { Types as LoaderTypes, Creators as modelCreators } from "model/data"
import { LOADING, ERROR, OK } from "helpers/data-statuses"
import { Creators as optimizationTradesCreators } from "modules/optimization-trades/model"
import { Creators as optimizationCreators } from "modules/optimization/model"
import { Creators as saveExperimentCreators } from "modules/save-experiment/model"
import { Creators as rebalanceCreators } from "modules/rebalance/model"
import actionCreator from "helpers/actionCreator"
import { getSelectedExperiment } from "./selectors/dates"
import { getSimulationConfig } from "./selectors"

export const { Types, Creators } = actionCreator("ompnt/modules/editExperiment/", {
  loadIndex: ["index"],
  setDate: ["date"],
  resetDate: [],
  reset: [],
  loadRebalanceConfig: [],
  loadExperimentConfigSuccess: [],
  loadExperimentConfigError: [],
})

const DEFAULT_STATE = {
  index: null,
  date: null,
  experiment: null,
  status: LOADING,
}

function handleLoadIndex(state, { index }) {
  return { ...state, index }
}

export function handleSetDate(state, { date }) {
  return { ...state, date: date.selectedDate }
}

export function handleResetDate(state) {
  return { ...state, date: null }
}

export function handleReset(state) {
  return { ...state, ...DEFAULT_STATE }
}

export const handleLoadSuccess = (state, action) => {
  if (action.resource === "experimentMeta") {
    return { ...state, experiment: action.data }
  } else {
    return state
  }
}

function handleLoadExperimentConfigSuccess(state) {
  return { ...state, status: OK }
}

function handleLoadExperimentConfigError(state) {
  return { ...state, error: "A technical error has happened. Please try again later.", status: ERROR }
}

export default createReducer(DEFAULT_STATE, {
  [Types.LOAD_INDEX]: handleLoadIndex,
  [Types.SET_DATE]: handleSetDate,
  [Types.RESET_DATE]: handleResetDate,
  [Types.RESET]: handleReset,
  [LoaderTypes.LOAD_SUCCESS]: handleLoadSuccess,
  [Types.LOAD_EXPERIMENT_CONFIG_SUCCESS]: handleLoadExperimentConfigSuccess,
  [Types.LOAD_EXPERIMENT_CONFIG_ERROR]: handleLoadExperimentConfigError,
})

function* handleNavigate(action) {
  const { optimizeExperiment, selectedExperiment, account, portfolio } = yield select(state => ({
    optimizeExperiment: get(state, "modules.optimization.experiment"),
    selectedExperiment: getSelectedExperiment(state),
    account: get(state, "global.selected.account"),
    portfolio: get(state, "global.selected.portfolio"),
  }))

  const pathName = get(action, "location.pathname")
  const experimentId = get(optimizeExperiment, "id") || get(selectedExperiment, "id")

  if (pathName.includes(`${account}/t/`)) {
    // If RT experiment, skip logic
    return
  }

  if (experimentId && pathName !== `/${account}/p/${portfolio}/experiments/${experimentId}/edit`) {
    if (optimizeExperiment) {
      yield put(optimizationTradesCreators.resetSettings())
      yield put(optimizationCreators.reloadConstraints())
    } else {
      yield put(rebalanceCreators.resetRebalance())
    }
    yield put(saveExperimentCreators.reset())
    yield put(modelCreators.resetCollections(["experimentMeta"]))
    yield put(Creators.reset())
  }
}

function* loadSuccess(action) {
  if (action.resource === "experimentMeta") {
    const experiment = get(action, "data")
    const experimentType = get(experiment, "type")

    if (experimentType === "OPTIMIZATION") {
      yield put(optimizationCreators.loadExperiment(experiment))
      yield put(Creators.loadExperimentConfigSuccess())
    }
  }
}

function* loadRebalanceConfig() {
  const { rebalanceConfig } = yield select(state => ({
    rebalanceConfig: getSimulationConfig(state),
  }))

  if (rebalanceConfig) {
    yield put(rebalanceCreators.loadExperimentConfig(rebalanceConfig))
    yield put(Creators.loadExperimentConfigSuccess())
  } else {
    yield put(Creators.loadExperimentConfigError())
  }
}

export function* saga() {
  yield takeLatest(Types.LOAD_REBALANCE_CONFIG, loadRebalanceConfig)
  yield takeLatest(HistoryTypes.NAVIGATE, handleNavigate)
  yield takeLatest(LoaderTypes.LOAD_SUCCESS, loadSuccess)
}
